export const translations = {
  en: {
    hero: {
      badge: 'New Consciousness Manual',
      title: 'Want To Wake Up From The Matrix',
      titleHighlight: 'Without Losing Yourself?',
      subtitle:
        'New Consciousness-Shifting Book Reveals 7 Hidden Codes To Remember Who You Really Are And Play The Real Game Of Life, Starting Today',
      description:
        'Awaken to your true power in the next 90 minutes using this mind-bending spiritual manual decoded from ancient wisdom and simulation science… even if you still feel stuck in fear, confusion, or endless self-improvement loops.',
      cta: "YES — I'M READY TO PLAY",
      audioLabel: 'Listen to the introduction:',
    },
    credibility: {
      readers: 'Trusted By Awakening Readers In Over 25 Countries',
      featured:
        'Featured in spiritual circles exploring consciousness, DMT, energy, and the Matrix phenomenon',
    },
    openingHook: {
      text: 'There are two types of humans: Those who spend their entire lives',
      reacting: 'reacting to the board',
      and: "… and those who realize they're the ones",
      controller: 'holding the controller',
      question: 'Which one are you?',
    },
    problem: {
      title:
        "If you're like most seekers, you're tired of feeling like something's missing",
      subtitle: "Like you were born for more, but can't remember what.",
      intro: "Right now, you're probably:",
      problems: [
        'Chasing success yet still feeling empty inside',
        'Watching others "manifest" while you struggle with chaos and fear',
        'Overwhelmed by endless "healing" advice that never sticks',
        'Wondering why the same patterns keep repeating—different faces, same pain',
        "Frustrated that you know reality is deeper … but can't see the code behind it",
      ],
      conclusion:
        'Every day you keep running the old program, you lose time, energy, and the chance to remember why you came here. And the worst part?',
      system: 'The system feeds on your distraction',
      soul: "Wake up… you're the player.",
    },
    story: {
      warning: 'WARNING',
      warningText:
        "What you're about to read will challenge everything you were taught about reality.",
      from: 'From:',
      author: 'Gabriel Beltrán',
      location: 'Location:',
      locationText: 'Earth, Level 3 Density',
      paragraph1:
        'I once lived asleep inside the system, working, achieving, repeating the same patterns. Then one day,',
      cracked: 'everything cracked.',
      paragraph2: "I realized my life wasn't random. It was",
      scripted: 'scripted.',
      paragraph2b:
        'But instead of panic, I felt clarity. What if this was a game and I could remember the rules?',
      paragraph3:
        'Years of research, deep meditations, and encounters with the molecule that reveals the code (DMT) uncovered the hidden architecture of reality. That journey became',
      bookTitle: 'Are You Ready To Play?',
      paragraph3b:
        'a guide for souls who are done obeying fear and ready to create consciously.',
    },
    opportunity: {
      title:
        "Right now, we're living in the greatest awakening window in human history.",
      subtitle:
        'Technology, energy, and consciousness are colliding — but most people are still hypnotized by the simulation.',
      heading: "Here's why this moment matters:",
      points: [
        'Quantum science now confirms what the mystics always knew:',
        'reality is code.',
        'The old systems built on fear and hierarchy are',
        'crumbling.',
        'Those who learn to play consciously are',
        'rewriting the collective game.',
      ],
      warning: "This window won't stay open forever.",
      warningText:
        'Every soul that remembers shifts the field — but delay, and the code closes back around you.',
    },
    solution: {
      intro: "Before I reveal what's inside, imagine this:",
      imagine: "You wake up tomorrow knowing exactly why you're here.",
      imagineText:
        'You stop chasing meaning because you are meaning. Fear dissolves. Synchronicities multiply. Life feels alive again.',
      title: 'Introducing Are You Ready To Play?',
      subtitle:
        'The 116-page spiritual technology that decodes reality and shows you how to play awake.',
      digital: 'Digital Edition',
      physical: 'Physical Book',
      instantDownload: 'Instant Download',
      shipped: 'Shipped To Your Door',
      shippingText: 'Please allow 14 days for shipping due to high demand',
      features: [
        'Instant digital access',
        'Read on any device',
        'Full audiobook included (1:49:47)',
      ],
      physicalFeatures: [
        'Premium printed edition',
        'Physical book to hold & cherish',
        'Digital Ebook included FREE',
        'Full audiobook included (1:49:47)',
      ],
      bonus: 'FREE BONUS',
      bonusTitle: 'DMT: The Spirit Molecule',
      bonusSubtitle: 'A Journey to Everything',
      bonusFormat: 'Audiobook + Digital Book',
      bonusValue: '($39.97 Value)',
      readMore: 'Read More',
      readLess: 'Read Less',
      ctaDigital: 'GET DIGITAL EDITION',
      ctaPhysical: 'GET PHYSICAL BOOK',
      helpText:
        "This isn't another self-help book. It's a manual for consciousness that will help you:",
      benefits: [
        'See the hidden system running your life',
        'Remember your true origin and purpose',
        'Rewrite the code of your reality through awareness',
      ],
      bonusDescription: {
        intro: 'Discover the molecule that bridges science and spirit.',
        paragraph1:
          'DMT: The Spirit Molecule is a profound exploration of consciousness, perception, and the hidden dimensions of reality. Written in lyrical, thought-provoking prose, this book blends scientific insight with spiritual depth, guiding the reader through one of the most mysterious substances in existence—N,N-Dimethyltryptamine (DMT).',
        uncover: 'Through its pages, you will uncover:',
        points: [
          '• The scientific story behind DMT and its natural presence in the human brain',
          '• The ancient Amazonian wisdom of Ayahuasca and its connection to the spirit world',
          '• The role of the pineal gland as a possible gateway to higher consciousness',
          '• The parallels between quantum physics and mystical experience',
          '• The transformative process of death, rebirth, and integration revealed through DMT',
        ],
        paragraph2:
          'Each chapter merges modern neuroscience with timeless spiritual understanding, revealing that the boundaries between the physical and the divine are far thinner than we imagine.',
        quote:
          "This book is not about escaping reality—it's about remembering what reality truly is.",
        detailsTitle: 'Details:',
        format: 'Format: Digital',
        length: 'Length: 92 pages',
        genre: 'Genre: Spirituality, Consciousness, Science & Philosophy',
      },
    },
    proof: {
      title: 'In just days of reading, readers report:',
      badges: [
        'Radical peace replacing anxiety',
        'Electric sensations of remembrance',
        'Synchronicities that confirm the code is responding',
      ],
      testimonials: [
        {
          quote: 'I felt like I was remembering something ancient.',
          author: 'E.M.',
        },
        {
          quote:
            "Every paragraph dismantled a belief I didn't know was programming.",
          author: 'S.T.',
        },
        {
          quote:
            'I stopped fighting life and started playing with it — and everything changed.',
          author: 'L.R.',
        },
      ],
    },
    whatYouGet: {
      title: "Here's Everything You Get When You Order Are You Ready To Play?",
      coreSystem: 'The Core System',
      value: '($47 Value)',
      items: [
        {
          title: 'The Veil Revealed',
          description:
            'Discover why you forgot who you are and how to remember.',
        },
        {
          title: 'The Hidden Rules Of The System',
          description:
            'Understand how fear, time, and identity keep you asleep.',
        },
        {
          title: 'The Awakening Sequence',
          description:
            'Step-by-step process to activate conscious play in daily life.',
        },
        {
          title: 'The Infinite Game Blueprint',
          description: 'Learn how to create reality from love, not survival.',
        },
      ],
      conclusion: 'This alone is worth',
      conclusionHighlight: '10x the price',
      conclusionText:
        '—because once you remember, nothing outside can control you again.',
    },
    guarantee: {
      title: 'My "Remember Who You Are" Promise',
      text: "If this book doesn't spark a genuine shift in your awareness within 7 days, just email",
      email: 'support@areyoureadytoplay.com',
      text2:
        'with the subject "Refund Request," and you\'ll receive a full refund within 24 hours — no questions asked.',
      highlight: 'You risk nothing. The only way to lose is by staying asleep.',
    },
    urgency: {
      title: 'Limited Time Offer',
      subtitle:
        'This special launch edition is limited. Once this first print run sells out, the price returns to $47.',
      points: [
        "Consciousness is accelerating — the next cycle won't wait.",
        'The sooner you remember, the faster your reality shifts.',
        'Delay only feeds the program.',
      ],
    },
    finalCTA: {
      title: 'You stand at a crossroads.',
      path1: 'Path 1',
      path1Text: 'Keep playing blind, repeating the same loops.',
      path2: 'Path 2',
      path2Text: 'Wake up and play consciously.',
      text: "Click the gold button below to begin. Fill in your details with confidence. In two minutes you'll receive instant access to the book that has already changed countless souls.",
      tomorrow: 'Tomorrow, you could see life with new eyes.',
      cta: "YES — I'M READY TO PLAY",
      guarantee: '30 Day Money-Back Guarantee',
    },
    finalClose: {
      title: 'Still on the fence? Remember:',
      points: [
        "You're protected by a 100% guarantee.",
        'You get $47 of value for $24.97 today.',
        'The only risk is continuing to play blind.',
      ],
      heading: 'Click Below And Begin The Real Game.',
      cta: "I'M READY TO REMEMBER",
      guarantee: '30 Day Money-Back Guarantee',
      ps: "P.S. Your awakening doesn't start when you finish the book.",
      psHighlight: 'It starts the moment you say yes.',
    },
    faq: {
      title: 'Frequently Asked Questions',
      questions: [
        {
          q: 'Who is this for?',
          a: "Anyone who feels the world is a game they don't understand — and wants to remember how to play awake.",
        },
        {
          q: 'Do I need to be "spiritual"?',
          a: 'No. You only need curiosity and the courage to question reality.',
        },
        {
          q: 'How long will it take to see results?',
          a: "Most readers feel a shift within the first three chapters — the moment they realize they're the observer, not the character.",
        },
        {
          q: 'Is this connected to religion?',
          a: "No. It's a universal framework that unites science, mysticism, and direct experience.",
        },
      ],
    },
    footer: {
      copyright: 'Copyright & Author Rights Disclaimer',
      copyrightText1:
        '©️ 2025 - Nicolás Pereira & Gabriel Beltrán - All rights reserved.',
      copyrightText2:
        'No part of this book may be reproduced, distributed, or transmitted in any form or by any means — electronic, mechanical, photocopying, recording, or otherwise — without the prior written permission of the author, except in the case of brief quotations used in reviews, articles, or scholarly work.',
      copyrightText3:
        'This book is a work of original authorship. The author retains all rights to the concepts, text, and intellectual property contained herein. Any unauthorized use, duplication, or adaptation of this material without explicit written consent is strictly prohibited and subject to applicable copyright laws.',
      terms: 'Terms & Policies',
      returns: 'Returns',
      allRights: 'Are You Ready To Play? All rights reserved.',
      termsModal: {
        title: 'Terms & Policies',
        sections: [
          {
            title: '1. Terms of Use',
            content:
              'By accessing and using this website, you accept and agree to be bound by these terms and conditions. If you do not agree with any part of these terms, you may not use our services.',
          },
          {
            title: '2. Intellectual Property',
            content:
              'All content on this website, including text, graphics, logos, images, and software, is the property of "Are You Ready To Play?" and is protected by copyright laws. Unauthorized use may violate copyright, trademark, and other laws.',
          },
          {
            title: '3. Privacy Policy',
            content:
              'We respect your privacy and are committed to protecting it. We do not sell, trade, or rent your personal information to others. Any information collected is used solely to process your order and improve your experience.',
          },
          {
            title: '4. Payment Processing',
            content:
              'All payments are processed securely through our payment processors. We do not store your full credit card details on our servers.',
          },
          {
            title: '5. Product Usage',
            content:
              'Our digital products are for personal use only. Redistribution, reproduction, or reselling of our products is strictly prohibited without explicit written permission.',
          },
          {
            title: '6. Limitation of Liability',
            content:
              '"Are You Ready To Play?" shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from the use or inability to use our products or services.',
          },
          {
            title: '7. Changes to Terms',
            content:
              'We reserve the right to modify these terms at any time. Your continued use of the website after changes indicates your acceptance of the modified terms.',
          },
        ],
      },
      returnsModal: {
        title: 'Returns & Refund Policy',
        sections: [
          {
            title: '30-Day Money-Back Guarantee',
            content:
              "We stand behind our product with a 30-day money-back guarantee. If you're not completely satisfied with your purchase, you can request a full refund within 30 days of your purchase.",
          },
          {
            title: 'Eligibility for Refunds',
            content:
              'To be eligible for a refund, you must have purchased the product directly from our official website. The 30-day period begins on the date of purchase.',
          },
          {
            title: 'How to Request a Refund',
            content:
              'To request a refund, simply visit the "My Account" section on our website and click on "Request Refund" next to your order. You can also use the "Request Refund" button in your order confirmation email.',
          },
          {
            title: 'Refund Processing',
            content:
              'Refunds are typically processed within 3-5 business days. The refund will be issued to the original payment method used for the purchase. Depending on your payment provider, it may take additional time for the refunded amount to appear in your account.',
          },
          {
            title: 'Digital Product Access After Refund',
            content:
              'Once a refund is processed, your access to the digital product will be revoked. This includes any downloadable files, online access, or audio content provided with the purchase.',
          },
          {
            title: 'No Questions Asked',
            content:
              "Our refund policy is simple – if you're not satisfied for any reason, you get your money back. No questions asked. We believe in the value of our product and want you to be completely satisfied with your purchase.",
          },
        ],
      },
    },
  },
  es: {
    hero: {
      badge: 'Nuevo Manual de Consciencia',
      title: '¿Quieres Despertar de la Matrix',
      titleHighlight: 'Sin Perderte a Ti Mismo?',
      subtitle:
        'Nuevo Libro Transformador de Consciencia Revela 7 Códigos Ocultos Para Recordar Quién Eres Realmente Y Jugar El Verdadero Juego de la Vida, Comenzando Hoy',
      description:
        'Despierta a tu verdadero poder en los próximos 90 minutos usando este manual espiritual alucinante decodificado de la sabiduría antigua y la ciencia de la simulación... incluso si todavía te sientes atrapado en el miedo, la confusión o ciclos interminables de auto-mejora.',
      cta: 'SÍ — ESTOY LISTO PARA JUGAR',
      audioLabel: 'Escucha la introducción:',
      testimonialCTA: {
        subheadline:
          'No tomes mi palabra — escucha lo que dice uno de nuestros alumnos',
        quote: 'Esto es lo que pasa cuando confías en el proceso…',
        cta: 'Mira cómo cambió su vida',
      },
    },
    credibility: {
      readers: 'Confiado Por Lectores Despertando En Más de 25 Países',
      featured:
        'Destacado en círculos espirituales explorando consciencia, DMT, energía y el fenómeno de la Matrix',
    },
    openingHook: {
      text: 'Hay dos tipos de humanos: Aquellos que pasan toda su vida',
      reacting: 'reaccionando al tablero',
      and: '... y aquellos que se dan cuenta de que son los que',
      controller: 'sostienen el control',
      question: '¿Cuál eres tú?',
    },
    problem: {
      title:
        'Si eres como la mayoría de los buscadores, estás cansado de sentir que falta algo',
      subtitle: 'Como si nacieras para más, pero no puedes recordar qué.',
      intro: 'En este momento, probablemente estés:',
      problems: [
        'Persiguiendo el éxito pero aún sintiéndote vacío por dentro',
        'Viendo a otros "manifestar" mientras luchas con el caos y el miedo',
        'Abrumado por consejos interminables de "sanación" que nunca funcionan',
        'Preguntándote por qué los mismos patrones siguen repitiéndose—diferentes caras, el mismo dolor',
        'Frustrado porque sabes que la realidad es más profunda... pero no puedes ver el código detrás de ella',
      ],
      conclusion:
        'Cada día que sigues ejecutando el viejo programa, pierdes tiempo, energía y la oportunidad de recordar por qué viniste aquí. ¿Y lo peor?',
      system: 'El sistema se alimenta de tu distracción',
      soul: 'Despierta... tú eres el jugador.',
    },
    story: {
      warning: 'ADVERTENCIA',
      warningText:
        'Lo que estás a punto de leer desafiará todo lo que te enseñaron sobre la realidad.',
      from: 'De:',
      author: 'Gabriel Beltrán',
      location: 'Ubicación:',
      locationText: 'Tierra, Densidad Nivel 3',
      paragraph1:
        'Una vez viví dormido dentro del sistema, trabajando, logrando, repitiendo los mismos patrones. Entonces un día,',
      cracked: 'todo se quebró.',
      paragraph2: 'Me di cuenta de que mi vida no era aleatoria. Estaba',
      scripted: 'programada.',
      paragraph2b:
        'Pero en lugar de pánico, sentí claridad. ¿Y si esto era un juego y podía recordar las reglas?',
      paragraph3:
        'Años de investigación, meditaciones profundas y encuentros con la molécula que revela el código (DMT) descubrieron la arquitectura oculta de la realidad. Ese viaje se convirtió en',
      bookTitle: '¿Estás Listo Para Jugar?',
      paragraph3b:
        'una guía para almas que han terminado de obedecer al miedo y están listas para crear conscientemente.',
    },
    opportunity: {
      title:
        'En este momento, estamos viviendo la mayor ventana de despertar en la historia humana.',
      subtitle:
        'La tecnología, la energía y la consciencia están colisionando — pero la mayoría de las personas todavía están hipnotizadas por la simulación.',
      heading: 'Por qué este momento importa:',
      points: [
        'La ciencia cuántica ahora confirma lo que los místicos siempre supieron:',
        'la realidad es código.',
        'Los viejos sistemas construidos sobre el miedo y la jerarquía están',
        'derrumbándose.',
        'Aquellos que aprenden a jugar conscientemente están',
        'reescribiendo el juego colectivo.',
      ],
      warning: 'Esta ventana no permanecerá abierta para siempre.',
      warningText:
        'Cada alma que recuerda cambia el campo — pero demora, y el código se cierra a tu alrededor nuevamente.',
    },
    solution: {
      intro: 'Antes de revelar lo que hay dentro, imagina esto:',
      imagine: 'Te despiertas mañana sabiendo exactamente por qué estás aquí.',
      imagineText:
        'Dejas de perseguir el significado porque tú eres el significado. El miedo se disuelve. Las sincronicidades se multiplican. La vida se siente viva de nuevo.',
      title: 'Presentando ¿Estás Listo Para Jugar?',
      subtitle:
        'La tecnología espiritual de 116 páginas que decodifica la realidad y te muestra cómo jugar despierto.',
      digital: 'Edición Digital',
      physical: 'Libro Físico',
      instantDownload: 'Descarga Instantánea',
      shipped: 'Enviado a Tu Puerta',
      shippingText:
        'Por favor permite 14 días para el envío debido a la alta demanda',
      features: [
        'Acceso digital instantáneo',
        'Lee en cualquier dispositivo',
        'Audiolibro completo incluido (1:49:47)',
        'Edición impresa premium',
        'Libro físico para sostener y apreciar',
        'Ebook digital incluido GRATIS',
      ],
      bundle: {
        title: 'Pack Despertar',
        subtitle: 'Total Incluye:',
        items: [
          '¿Estás listo para jugar? (audio + eBook) – Valor: US$24.97',
          'Meditaciones Guiadas (audio binaural) – Valor: US$47.00',
          'BONUS: DMT – La Molécula de Dios (audio + eBook) – Valor: US$24.97',
        ],
        cta: 'OBTENER PACK DESPERTAR',
        meditationDetails: {
          title: 'Programa de Meditación Guiada: 30 Días para Despertar tu Ser',
          masterclass:
            'Incluye acceso a la Masterclass: "El Verdadero Secreto de los Élites" (1 hora)',
          intro:
            'Embárcate en una travesía de 30 días hacia la expansión de tu conciencia. Este programa no es solo una serie de meditaciones: es un sistema de transformación diseñado para reprogramar tu mente, equilibrar tu energía y reconectarte con tu esencia creadora.',
          experienceTitle: 'Lo que vivirás durante los 30 días',
          experienceText:
            'Cada semana está meticulosamente estructurada para guiarte por cuatro fases evolutivas:',
          week1Title: 'Semana 1 – Despertando la Conciencia Plena',
          week1Text:
            'Inicia tu práctica con meditaciones matutinas, de mediodía y vespertinas que te ayudan a silenciar la mente y restaurar tu energía. Incluye el video especial "El Verdadero Secreto de los Élites" —una clase magistral de 1 hora que expone los mecanismos mentales y emocionales que las élites utilizan para controlar la atención colectiva, y cómo liberarte de esa programación.',
          week2Title: 'Semana 2 – Profundizando en la Práctica',
          week2Text:
            'Aprende a observar tus pensamientos sin apego y a expandir tu conciencia corporal a través de técnicas de respiración y presencia consciente.',
          week3Title: 'Semana 3 – Expansión de la Conciencia',
          week3Text:
            'Activa la compasión, la gratitud y el amor incondicional. Más del 70 % de los practicantes reportan una disminución notable del estrés y un 82 % una claridad mental ampliada en esta fase.',
          week4Title: 'Semana 4 – Integración y Trascendencia',
          week4Text:
            'Disuelve las limitaciones mentales y habita tu estado natural de paz inquebrantable con la Meditación de Trascendencia y la práctica final de Abundancia.',
          benefitsTitle: 'Beneficios comprobados',
          benefits: [
            'Reducción del estrés y la ansiedad',
            'Sueño profundo y restaurador',
            'Claridad mental y enfoque sostenido',
            'Elevación energética y emocional',
            'Despertar intuitivo y expansión interior',
          ],
          includesTitle: 'Incluye además:',
          includes: [
            'Acceso completo al programa de 30 días (audio + guía digital)',
            'Masterclass de 1 hora "El Verdadero Secreto de los Élites"',
            'Meditaciones especiales de abundancia y manifestación',
            'Comunidad privada de apoyo',
          ],
          value: 'Valor total del programa: US $47.00',
          investment:
            'Tu inversión hoy: US $49.97 (incluido en el Pack Despertar Total)',
        },
      },
      physicalFeatures: [
        'Edición impresa premium',
        'Libro físico para sostener y apreciar',
        'Ebook digital incluido GRATIS',
        'Audiolibro completo incluido (1:49:47)',
      ],
      bonus: 'BONO GRATIS',
      bonusTitle: 'DMT: La Molécula Espiritual',
      bonusSubtitle: 'Un Viaje a Todo',
      bonusFormat: 'Audiolibro + Libro Digital',
      bonusValue: '($39.97 Valor)',
      readMore: 'Leer Más',
      readLess: 'Leer Menos',
      ctaDigital: 'OBTENER EDICIÓN DIGITAL',
      ctaPhysical: 'OBTENER LIBRO FÍSICO',
      helpText:
        'Este no es otro libro de autoayuda. Es un manual de consciencia que te ayudará a:',
      benefits: [
        'Ver el sistema oculto que dirige tu vida',
        'Recordar tu verdadero origen y propósito',
        'Reescribir el código de tu realidad a través de la consciencia',
      ],
      bonusDescription: {
        intro: 'Descubre la molécula que une ciencia y espíritu.',
        paragraph1:
          'DMT: La Molécula Espiritual es una exploración profunda de la consciencia, la percepción y las dimensiones ocultas de la realidad. Escrito en prosa lírica y provocadora, este libro combina conocimiento científico con profundidad espiritual, guiando al lector a través de una de las sustancias más misteriosas que existen—N,N-Dimetiltriptamina (DMT).',
        uncover: 'A través de sus páginas, descubrirás:',
        points: [
          '• La historia científica detrás del DMT y su presencia natural en el cerebro humano',
          '• La sabiduría ancestral amazónica de la Ayahuasca y su conexión con el mundo espiritual',
          '• El papel de la glándula pineal como posible portal a la consciencia superior',
          '• Los paralelos entre la física cuántica y la experiencia mística',
          '• El proceso transformador de muerte, renacimiento e integración revelado a través del DMT',
        ],
        paragraph2:
          'Cada capítulo fusiona la neurociencia moderna con el entendimiento espiritual atemporal, revelando que los límites entre lo físico y lo divino son mucho más delgados de lo que imaginamos.',
        quote:
          'Este libro no trata de escapar de la realidad—trata de recordar lo que la realidad realmente es.',
        detailsTitle: 'Detalles:',
        format: 'Formato: Digital',
        length: 'Longitud: 92 páginas',
        genre: 'Género: Espiritualidad, Consciencia, Ciencia y Filosofía',
      },
    },
    proof: {
      title: 'En solo días de lectura, los lectores reportan:',
      badges: [
        'Paz radical reemplazando la ansiedad',
        'Sensaciones eléctricas de recuerdo',
        'Sincronicidades que confirman que el código está respondiendo',
      ],
      testimonials: [
        {
          quote: 'Sentí como si estuviera recordando algo ancestral.',
          author: 'E.M.',
        },
        {
          quote:
            'Cada párrafo desmanteló una creencia que no sabía que era programación.',
          author: 'S.T.',
        },
        {
          quote:
            'Dejé de luchar contra la vida y comencé a jugar con ella — y todo cambió.',
          author: 'L.R.',
        },
      ],
    },
    whatYouGet: {
      title:
        'Esto Es Todo Lo Que Obtienes Cuando Ordenas ¿Estás Listo Para Jugar?',
      coreSystem: 'El Sistema Central',
      value: '($47 Valor)',
      items: [
        {
          title: 'El Velo Revelado',
          description: 'Descubre por qué olvidaste quién eres y cómo recordar.',
        },
        {
          title: 'Las Reglas Ocultas Del Sistema',
          description:
            'Entiende cómo el miedo, el tiempo y la identidad te mantienen dormido.',
        },
        {
          title: 'La Secuencia del Despertar',
          description:
            'Proceso paso a paso para activar el juego consciente en la vida diaria.',
        },
        {
          title: 'El Plan del Juego Infinito',
          description:
            'Aprende a crear realidad desde el amor, no desde la supervivencia.',
        },
      ],
      conclusion: 'Esto solo vale',
      conclusionHighlight: '10 veces el precio',
      conclusionText:
        '—porque una vez que recuerdas, nada externo puede controlarte de nuevo.',
    },
    guarantee: {
      title: 'Mi Promesa "Recuerda Quién Eres"',
      text: 'Si este libro no despierta un cambio genuino en tu consciencia dentro de 7 días, simplemente envía un correo a',
      email: 'support@areyoureadytoplay.com',
      text2:
        'con el asunto "Solicitud de Reembolso," y recibirás un reembolso completo dentro de 24 horas — sin preguntas.',
      highlight:
        'No arriesgas nada. La única forma de perder es permanecer dormido.',
    },
    urgency: {
      title: 'Oferta Por Tiempo Limitado',
      subtitle:
        'Esta edición especial de lanzamiento es limitada. Una vez que se agote esta primera tirada, el precio vuelve a $47.',
      points: [
        'La consciencia se está acelerando — el próximo ciclo no esperará.',
        'Cuanto antes recuerdes, más rápido cambiará tu realidad.',
        'Retrasar solo alimenta el programa.',
      ],
    },
    finalCTA: {
      title: 'Estás en una encrucijada.',
      path1: 'Camino 1',
      path1Text: 'Seguir jugando ciego, repitiendo los mismos ciclos.',
      path2: 'Camino 2',
      path2Text: 'Despertar y jugar conscientemente.',
      text: 'Haz clic en el botón dorado a continuación para comenzar. Completa tus detalles con confianza. En dos minutos recibirás acceso instantáneo al libro que ya ha cambiado innumerables almas.',
      tomorrow: 'Mañana, podrías ver la vida con nuevos ojos.',
      cta: 'SÍ — ESTOY LISTO PARA JUGAR',
      guarantee: 'Garantía de Devolución de Dinero de 30 Días',
    },
    finalClose: {
      title: '¿Aún indeciso? Recuerda:',
      points: [
        'Estás protegido por una garantía del 100%.',
        'Obtienes $47 de valor por $24.97 hoy.',
        'El único riesgo es seguir jugando ciego.',
      ],
      heading: 'Haz Clic Abajo Y Comienza El Juego Real.',
      cta: 'ESTOY LISTO PARA RECORDAR',
      guarantee: 'Garantía de Devolución de Dinero de 30 Días',
      ps: 'P.D. Tu despertar no comienza cuando terminas el libro.',
      psHighlight: 'Comienza en el momento en que dices que sí.',
    },
    faq: {
      title: 'Preguntas Frecuentes',
      questions: [
        {
          q: '¿Para quién es esto?',
          a: 'Para cualquiera que sienta que el mundo es un juego que no entiende — y quiere recordar cómo jugar despierto.',
        },
        {
          q: '¿Necesito ser "espiritual"?',
          a: 'No. Solo necesitas curiosidad y el coraje de cuestionar la realidad.',
        },
        {
          q: '¿Cuánto tiempo tomará ver resultados?',
          a: 'La mayoría de los lectores sienten un cambio dentro de los primeros tres capítulos — el momento en que se dan cuenta de que son el observador, no el personaje.',
        },
        {
          q: '¿Está conectado con la religión?',
          a: 'No. Es un marco universal que une la ciencia, el misticismo y la experiencia directa.',
        },
      ],
    },
    footer: {
      copyright: 'Derechos de Autor y Descargo de Responsabilidad',
      copyrightText1:
        '©️ 2025 - Nicolás Pereira & Gabriel Beltrán - Todos los derechos reservados.',
      copyrightText2:
        'Ninguna parte de este libro puede ser reproducida, distribuida o transmitida en cualquier forma o por cualquier medio — electrónico, mecánico, fotocopia, grabación u otro — sin el permiso previo por escrito del autor, excepto en el caso de citas breves utilizadas en reseñas, artículos o trabajos académicos.',
      copyrightText3:
        'Este libro es una obra de autoría original. El autor retiene todos los derechos sobre los conceptos, el texto y la propiedad intelectual contenidos en el mismo. Cualquier uso no autorizado, duplicación o adaptación de este material sin consentimiento explícito por escrito está estrictamente prohibido y sujeto a las leyes de derechos de autor aplicables.',
      terms: 'Términos y Políticas',
      returns: 'Devoluciones',
      allRights: '¿Estás Listo Para Jugar? Todos los derechos reservados.',
      termsModal: {
        title: 'Términos y Políticas',
        sections: [
          {
            title: '1. Términos de Uso',
            content:
              'Al acceder y usar este sitio web, aceptas y te comprometes a cumplir con estos términos y condiciones. Si no estás de acuerdo con alguna parte de estos términos, no puedes usar nuestros servicios.',
          },
          {
            title: '2. Propiedad Intelectual',
            content:
              'Todo el contenido de este sitio web, incluyendo texto, gráficos, logos, imágenes y software, es propiedad de "¿Estás Listo Para Jugar?" y está protegido por las leyes de derechos de autor. El uso no autorizado puede violar los derechos de autor, marcas registradas y otras leyes.',
          },
          {
            title: '3. Política de Privacidad',
            content:
              'Respetamos tu privacidad y estamos comprometidos a protegerla. No vendemos, intercambiamos ni alquilamos tu información personal a otros. Cualquier información recopilada se utiliza únicamente para procesar tu pedido y mejorar tu experiencia.',
          },
          {
            title: '4. Procesamiento de Pagos',
            content:
              'Todos los pagos se procesan de forma segura a través de nuestros procesadores de pagos. No almacenamos los detalles completos de tu tarjeta de crédito en nuestros servidores.',
          },
          {
            title: '5. Uso del Producto',
            content:
              'Nuestros productos digitales son solo para uso personal. La redistribución, reproducción o reventa de nuestros productos está estrictamente prohibida sin permiso explícito por escrito.',
          },
          {
            title: '6. Limitación de Responsabilidad',
            content:
              '"¿Estás Listo Para Jugar?" no será responsable de ningún daño directo, indirecto, incidental, especial o consecuente que resulte del uso o la imposibilidad de usar nuestros productos o servicios.',
          },
          {
            title: '7. Cambios en los Términos',
            content:
              'Nos reservamos el derecho de modificar estos términos en cualquier momento. Tu uso continuo del sitio web después de los cambios indica tu aceptación de los términos modificados.',
          },
        ],
      },
      returnsModal: {
        title: 'Política de Devoluciones y Reembolsos',
        sections: [
          {
            title: 'Garantía de Devolución de Dinero de 30 Días',
            content:
              'Respaldamos nuestro producto con una garantía de devolución de dinero de 30 días. Si no estás completamente satisfecho con tu compra, puedes solicitar un reembolso completo dentro de los 30 días posteriores a tu compra.',
          },
          {
            title: 'Elegibilidad para Reembolsos',
            content:
              'Para ser elegible para un reembolso, debes haber comprado el producto directamente desde nuestro sitio web oficial. El período de 30 días comienza en la fecha de compra.',
          },
          {
            title: 'Cómo Solicitar un Reembolso',
            content:
              'Para solicitar un reembolso, simplemente visita la sección "Mi Cuenta" en nuestro sitio web y haz clic en "Solicitar Reembolso" junto a tu pedido. También puedes usar el botón "Solicitar Reembolso" en tu correo electrónico de confirmación de pedido.',
          },
          {
            title: 'Procesamiento de Reembolsos',
            content:
              'Los reembolsos generalmente se procesan dentro de 3-5 días hábiles. El reembolso se emitirá al método de pago original utilizado para la compra. Dependiendo de tu proveedor de pagos, puede tomar tiempo adicional para que el monto reembolsado aparezca en tu cuenta.',
          },
          {
            title: 'Acceso al Producto Digital Después del Reembolso',
            content:
              'Una vez que se procesa un reembolso, tu acceso al producto digital será revocado. Esto incluye cualquier archivo descargable, acceso en línea o contenido de audio proporcionado con la compra.',
          },
          {
            title: 'Sin Preguntas',
            content:
              'Nuestra política de reembolso es simple: si no estás satisfecho por cualquier motivo, recuperas tu dinero. Sin preguntas. Creemos en el valor de nuestro producto y queremos que estés completamente satisfecho con tu compra.',
          },
        ],
      },
    },
  },
}
